export default __webpack_public_path__ + "static/media/sidebar-3.00b17713.jpg";